import type { ContentParameters, Page } from '../api/types';

export function resolvePageSlug(
  pages: Page[] | undefined,
  content_parameters: ContentParameters,
): string {
  switch (content_parameters.content_type) {
    case 'album':
    case 'article':
    case 'collection':
    case 'gallery':
    case 'playlist':
    case 'podcast':
    case 'video':
    case 'quiz':
    case 'game':
      return `/${content_parameters.content_type}/${content_parameters.content?.id}`;
    case 'page':
      const page = pages?.find(p => p.id === content_parameters.content?.id);
      return `/${page?.slug}`;
    default:
      throw new Error('Unrecognized content type');
  }
}
